import cuid from 'cuid';
import { useHistory } from 'react-router-dom';
import { AutomationEditorView } from '../types/AutomationEditorView';
import { useGetAutomationsBasePath } from './useGetAutomationsBasePath';

export const DRAFT = 'draft';

export const useAddNewAutomation = (): { handleAddNewAutomation: () => void } => {
  const history = useHistory();
  const { automationsBasePath } = useGetAutomationsBasePath();

  const handleAddNewAutomation = (): void => {
    const draftId = cuid();
    history.push(`${automationsBasePath}/${DRAFT}-${draftId}/${AutomationEditorView.Settings}`);
  };

  return { handleAddNewAutomation };
};
